module.exports = __webpack_public_path__ + "img/zhuhai-3.bc17c785.jpg";